import $ from "jquery";

const header = $("header.header-section"),
  fullscreenMenuButton = $(".menu-button"),
  fullScreenMenu = $(".header-menu");

function closeMobNav() {
  header.removeClass("menu-opened");
  fullscreenMenuButton.removeClass("menu-opened").addClass("menu-closed");

  $("html").css({
    overflow: "visible",
    left: "auto",
    right: "auto",
    top: "auto",
    bottom: "auto",
    position: "static",
  });
}

fullscreenMenuButton.on("click", function () {
  if (fullscreenMenuButton.hasClass("menu-opened")) {
    closeMobNav();
    fullScreenMenu.slideUp();
  } else {
    fullScreenMenu.css("position", "absolute").slideDown();
    fullscreenMenuButton.removeClass("menu-closed").addClass("menu-opened");
    header.addClass("menu-opened");
    $("html").css({
      overflow: "hidden",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
    });
  }
});

$(window).resize(function () {

  const win = $(this);
  if (win.width() >= 992) {
    closeMobNav();
    fullScreenMenu.removeAttr('style');
  }
});
